module.exports = __webpack_public_path__ + "static/media/lco.3ab966fe.png";